const constants = {
  googleClassroomCoursesCallbackRoute: '/google-classroom-courses',
  googleClassroomCourseStudentsCallbackRoute:
    '/google-classroom-course-students',
  emailListPlacholder: `  user.one@email.com; My User
  user.two@email.com; My User...`,
};

export default constants;
